import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import SMCLabel from '../../components/Simple/SMCLabel';
import SMCFileInput from '../../components/Simple/SMCFileInput';
import Sepperator from '../../components/Simple/Sepperator';
import {readFileContent, validateMacAddress} from '../../utils/utils';

function SetMacFileModal({
    isOpen,
    onRequestClose,
    onFinish
}) {
    const { t } = useTranslation();

    const [macAddressFile, setMacAddressFile] = useState(null);

    const handleFinish = async () => {
        try {
            if (!macAddressFile) {
                onFinish(null);
                return;
            }
            const content = await readFileContent(macAddressFile);
            if (!content) {
                onFinish(null);
                return;
            }
            const macAddressArray = content.split(/\r?\n/);
            for (let i = 0; i < macAddressArray.length; i++) {
                const macAddress = macAddressArray[i];
                if (!validateMacAddress(macAddress)) {
                    alert(t('com.sofaware.schema.ATTRIBUTE_INVALID_VALUE_MAC', [macAddress, t('SMC_GATEWAY_MAC')]));
                    return;
                }   
            }
            onFinish(macAddressArray);
        }
        catch (e) {
            alert(t('SMC_LOADFILE_EMPTY'));
        }
    };

    // Reset values on each new open
    useEffect(() => {
        if (isOpen) {
            setMacAddressFile(null);
        }
    }, [isOpen]);
    
    return (
        <SMCModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            height={240}
            width={420}
            title={t('SMC_LOADFILE_TITLE')}
        >
            <SMCModalBody lineHeight="22px" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                <SMCFileInput
                    label={t('SMC_LOADFILE_FILE')}
                    onChange={fileList => {
                        if (fileList && fileList.length) {
                            setMacAddressFile(fileList[0]);
                        } else {
                            setMacAddressFile(undefined);
                        }
                    }}
                />
                <Sepperator />
                <SMCLabel fontSize="8pt">{t('SMC_LOADFILE_LOWTEXT')}</SMCLabel>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={handleFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_OK')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default SetMacFileModal;